import React, { useEffect } from 'react';
import '../../styles/Adn.css';
import images from '../../data/introductionPhotos.json'; // Importar JSON

const Introduction = () => {
  useEffect(() => {
    const handleScroll = () => {
      const images = document.querySelectorAll('.parallax-image');
      images.forEach((image) => {
        const speed = image.getAttribute('data-speed');
        const offset = window.pageYOffset * speed;
        image.style.transform = `translateY(${offset}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="introduction-section">
      <div className='container'>
        {/* Título */}
        <div className="title-container" data-aos="fade-up">
          <h2 className="title">Nuestro ADN</h2>
          <div className="title-underline"></div>
        </div>

        {/* Contenido principal */}
        <div className="row align-items-center" data-aos="fade-up">
          {/* Columna de texto */}
          <div className="col-md-6 text-content order-2 order-lg-1 section-description" style={{ textAlign: 'left' }}>
            <p>
              Promovemos el bienestar en Puerto Rico, educando en salud física,
              mental y emocional, inspirando hábitos que transforman vidas.
              <br />
              <br />
              <span className="description-highlight">
                Aspiramos a ser referentes, guiados siempre por nuestros valores,
                soñando con un futuro donde la salud inspire y los cambios
                florezcan en cada persona.
              </span>
            </p>
          </div>

          {/* Columna de imágenes */}
          <div className="col-md-6 image-gallery order-1 order-lg-2">
            <div className="image-stack">
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image.src}
                  alt={image.alt}
                  className="parallax-image"
                  data-speed={image.speed}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;




